/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.TicketsRpc
 */

export const BooleanFieldValueDiscriminant = 'boolean';
export const BooleanFieldValueDiscriminantKey = '@type';
export const DoubleFieldValueDiscriminant = 'double';
export const DoubleFieldValueDiscriminantKey = '@type';
export const FieldValueDiscriminantKey = '@type';
export const FloatFieldValueDiscriminant = 'float';
export const FloatFieldValueDiscriminantKey = '@type';
export const IntFieldValueDiscriminant = 'integer';
export const IntFieldValueDiscriminantKey = '@type';
export const ListFieldValueDiscriminant = 'list';
export const ListFieldValueDiscriminantKey = '@type';
export const LongFieldValueDiscriminant = 'long';
export const LongFieldValueDiscriminantKey = '@type';
export const MapFieldValueDiscriminant = 'map';
export const MapFieldValueDiscriminantKey = '@type';
export const NullFieldValueDiscriminant = 'null';
export const NullFieldValueDiscriminantKey = '@type';
export const StringFieldValueDiscriminant = 'string';
export const StringFieldValueDiscriminantKey = '@type';
export const ConsentErrorDiscriminant = 'CONSENT';
export const ConsentErrorDiscriminantKey = '@type';
export const CustomerSuccessPortalErrorDiscriminant = 'CUSTOMER_SUCCESS_PORTAL';
export const CustomerSuccessPortalErrorDiscriminantKey = '@type';
export const NotificationErrorDiscriminant = 'NOTIFICATION';
export const NotificationErrorDiscriminantKey = '@type';
export const PortalAuthErrorDiscriminant = 'AUTH';
export const PortalAuthErrorDiscriminantKey = '@type';
export const PortalPublicRpcErrorDiscriminantKey = '@type';
export const SettingsErrorDiscriminant = 'SETTINGS';
export const SettingsErrorDiscriminantKey = '@type';
export const SupportPortalErrorDiscriminant = 'SUPPORT_PORTAL';
export const SupportPortalErrorDiscriminantKey = '@type';
export const TrackEventErrorDiscriminant = 'TRACK_EVENT';
export const TrackEventErrorDiscriminantKey = '@type';
export const TranslationsErrorDiscriminant = 'TRANSLATIONS';
export const TranslationsErrorDiscriminantKey = '@type';
export const searchTicketsRpc = {
  serviceName: 'com.hubspot.support.portal.rpc.TicketsRpc',
  rpcName: 'searchTickets',
  auth: 'external',
  fingerprint: 'MzfjqfWDXP0WFsy7KaqgYXOjsnBdk3FP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchTicketsForNavigationRpc = {
  serviceName: 'com.hubspot.support.portal.rpc.TicketsRpc',
  rpcName: 'searchTicketsForNavigation',
  auth: 'external',
  fingerprint: 'D5PITdkjvn1ktUH1-p3zuHOjsnBdk3FP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getTicketDetailsRpc = {
  serviceName: 'com.hubspot.support.portal.rpc.TicketsRpc',
  rpcName: 'getTicketDetails',
  auth: 'external',
  fingerprint: '182rS8rv9QSD6f8AxUmQ3XOjsnBdk3FP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getTicketContactsRpc = {
  serviceName: 'com.hubspot.support.portal.rpc.TicketsRpc',
  rpcName: 'getTicketContacts',
  auth: 'external',
  fingerprint: '60LvgeypUfI99F2W0T9n8HOjsnBdk3FP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const closeTicketRpc = {
  serviceName: 'com.hubspot.support.portal.rpc.TicketsRpc',
  rpcName: 'closeTicket',
  auth: 'external',
  fingerprint: 'Hdgr46mh59sUmN0mpFaz43OjsnBdk3FP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};